import { render, staticRenderFns } from "./ServicioLista.vue?vue&type=template&id=f45d3d3a"
import script from "./ServicioLista.vue?vue&type=script&lang=js"
export * from "./ServicioLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports